export default class ContactSelector {
    #selectorElement;
    #contactElement;

    constructor(element) {
        this.#selectorElement = element;
        this.#contactElement = document.getElementById(element.dataset.target);

        this.#bindEvents();
    }

    static initAll(selector) {
        Array.from(document.querySelectorAll(selector), (element) => new ContactSelector(element));
    }

    #bindEvents() {
        this.#selectorElement.addEventListener('change', this.#handleSelectorChange);
    }

    #handleSelectorChange = () => {
        const selectedOption = this.#selectorElement.options[this.#selectorElement.selectedIndex];
        
        if (selectedOption.value !== '') {
            this.#contactElement.value = selectedOption.innerText.trim();
        }
    };
}
